@if (type === 'simple') {
  <div>
    <button
      mat-stroked-button
      class="table-btn"
      [glxyPopover]="simpleSort"
      (click)="isOpen = true"
      data-action="clicked-glxy-table-columns-button"
      >
      <span class="table-btn-icon"><mat-icon>view_column</mat-icon></span>
      <span class="hide-on-small">{{ 'GALAXY.TABLE.COLUMN_SORT.BUTTON_LABEL' | translate }}</span>
    </button>
    <glxy-popover
      #simpleSort
      [isOpen]="isOpen"
      [hasBackdrop]="true"
      [showBackdrop]="false"
      (backdropClick)="isOpen = false"
      [hasArrow]="true"
      [maxHeight]="'100%'"
      [padding]="'none'"
      [positions]="[PopoverPositions.BottomRight]"
      >
      @if (columns$ | async; as columns) {
        <glxy-column-sort-simple [columns]="columns" />
      }
    </glxy-popover>
  </div>
}
@if (type === 'advanced') {
  <div>
    @if (groupConfigs$ | async; as groupConfigs) {
      @if (columns$ | async; as columnConfigs) {
        <glxy-mat-table-advanced-column-organizer-button
          [groupConfigs]="groupConfigs"
          [columnConfigs]="columnConfigs"
          data-action="clicked-glxy-table-columns-button"
          >
          <span class="table-btn-icon"><mat-icon>view_column</mat-icon></span>
          <span class="hide-on-small">{{ 'GALAXY.TABLE.COLUMN_SORT.BUTTON_LABEL' | translate }}</span>
        </glxy-mat-table-advanced-column-organizer-button>
      }
    }
  </div>
}
